import { Injectable } from "@angular/core";
import { ConfigModel } from "../models/config.model";

@Injectable()
export class ConfigStore {

    private storeKey: string = 'zefiro.pocket.app.config.store';

    public currentVersion = '0.1.0';

    public data: ConfigModel = null;

    constructor() {
        this.load();
    }

    getValue(name: string) {
        return this.data[name];
    }

    load() {

        let str: string = localStorage.getItem(this.storeKey);

        if (str)
            this.data = JSON.parse(str);
                
        // ToDo: codice provvisorio, completare...
        if (!this.data)
            this.data = new ConfigModel();

        this.data.webServiceURL = window.location.origin; // Note(Moris): recupera HOST e PROTOCOL dall'URL della pagina
    }

    save() {
        localStorage.setItem(this.storeKey, JSON.stringify(this.data));
    }
}


// WEBPACK FOOTER //
// ./src/stores/config.store.ts